<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <h1 class="mt-4">
            hi, here you kannst yourself austoben....
          </h1>
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-input
            label="Input"
            placeholder="placeholder"
          />
          <br>
          <br>
          <dx-input
            label="Input disabeld"
            placeholder="placeholder disabeld"
            disabled
          />
          <br>
          <br>
          <dx-input
            label="Input"
            value="Error Value"
            error="Error Text"
          />
          <br>
          <br>
          <dx-input
            label="Input with icon"
            placeholder="placeholder with icon"
            has-icon="blue-check"
          />
          <br>
          <br>
          <dx-input
            label="Input with icon disabled"
            placeholder="placeholder with icon disabled"
            has-icon="blue-check"
            disabled
          />
          <br>
          <br>
          <dx-input
            label="Input Date"
            is-date-input
          />
          <br>
          <br>
          <dx-input
            label="Input Date disabeld"
            is-date-input
            disabled
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-button
            text="Test notifications"
            @click="$notification.info({})"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-textarea
            label="Textarea"
            placeholder="placeholder"
          />
          <br>
          <br>
          <dx-textarea
            :rows="1"
            label="Textarea"
            value="Textarea + 2 rows"
            error="Error Text"
          />
          <br>
          <br>
          <dx-textarea
            :rows="2"
            label="Textarea disabeld"
            value="Textarea Options: disabeld + 2 rows"
            disabled
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-button
            text="I am a button"
            route-name="/"
          />
        </div>
        <div class="col">
          <dx-button
            text="I am a button"
            theme="wine"
            icon="lightning"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-button
            :small="true"
            text="I am a button"
            theme="crayola"
            icon="lightning"
          />
        </div>
        <div class="col">
          <dx-button
            :small="true"
            text="I am a button"
            theme="wine"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-button
            :ghost="true"
            text="I am a button"
            theme="crayola"
          />
        </div>
        <div class="col">
          <dx-button
            :ghost="true"
            text="I am a button"
            theme="wine"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-radio-check
            id="id_01"
            label="Checkbox Number 1"
            name="checkbox_group_1"
            type="checkbox"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-radio-check
            id="id_02"
            label="Radio Number 1"
            name="radio_element_1"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-radio-list
            :options="[
              {
                text: 'Option 1',
                id: 'option_1',
              },
              {
                text: 'Option 2',
                id: 'option_2',
              }
            ]"
            label="Radio List Label"
            name="multi_radio_1"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <div class="shadow-container shadow-container--width">
            I am a shadow container
          </div>
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-select
            :options="[
              { value: 1, label: 'YOUR_OPTION 1'},
              { value: 2, label: 'YOUR_OPTION 2', caption: true},
            ]"
            label="Select/Dropdown"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-select
            :options="[
              { value: 1, label: 'YOUR_OPTION 1', caption: true},
              { value: 2, label: 'YOUR_OPTION 2'},
            ]"
            label="Select/Dropdown with error"
            error="I am a error"
          />
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col">
          <dx-accordion>
            <template slot="headline">
              I am the visible headline
            </template>

            <template slot="content">
              I am the hidden content
            </template>
          </dx-accordion>
        </div>
      </div>

      <dx-shadow-page-head
        title="Benachrichtigung"
        icon-class="warning"
      >
        <template slot="shadow-page-head-content">
          <ul class="neutral">
            <li
              v-for="item in testData"
              :key="item"
              class="mb-3"
            >
              <div class="row">
                <span class="col-7 col-md-9">
                  {{ item.headline }}
                </span>
                <a
                  tabindex="0"
                  class="col-5 col-md-3 text-right secondary-link link"
                >
                  Ansehen
                </a>
              </div>
            </li>
          </ul>
        </template>
      </dx-shadow-page-head>

      <div class="row my-5">
        <div class="col">
          <dx-tooltip
            :show-delete-dialog="true"
            position="right"
          >
            <template slot="trigger">
              Was geht ab
            </template>
          </dx-tooltip>
        </div>
      </div>
      <br>
      <div class="row my-5">
        <div class="col text-center">
          <dx-tooltip
            position="top-left"
          >
            <template slot="trigger">
              Ich wurde per SLOT eingefügt - Position TOP LEFT
            </template>

            <template slot="content">
              Ich bin cooler content der per slot eingefügt wurde
            </template>
          </dx-tooltip>
        </div>
      </div>
      <br>
      <div class="row my-5">
        <div class="col text-center">
          <dx-tooltip
            position="top-center"
          >
            <template slot="trigger">
              Ich wurde per SLOT eingefügt - Ich wurde per SLOT eingefügt - Position TOP CENTER
            </template>

            <template slot="content">
              Ich bin cooler content der per slot eingefügt wurde
            </template>
          </dx-tooltip>
        </div>
      </div>
      <br>
      <div class="row my-5">
        <div class="col text-center">
          <dx-tooltip
            position="top-right"
          >
            <template slot="trigger">
              Ich wurde per SLOT eingefügt - Position TOP RIGHT
            </template>

            <template slot="content">
              Ich bin so ein content Slot
            </template>
          </dx-tooltip>
        </div>
      </div>
      <br>
      <br>
      <div class="row my-5">
        <div class="col text-center">
          <dx-tooltip
            position="right"
          >
            <template slot="trigger">
              Slot Slot Slot - Position Right
            </template>

            <template slot="content">
              Ich bin so ein content Slot
            </template>
          </dx-tooltip>
        </div>
      </div>
      <br>
      <br>
      <div class="row my-5">
        <div class="col text-center">
          <dx-tooltip
            position="bottom-right"
          >
            <template slot="trigger">
              Slot Slot Slot Ich wurde per SLOT eingefügt  - Position Bottom Right
            </template>

            <template slot="content">
              Ich bin so ein content Slot
            </template>
          </dx-tooltip>
        </div>
      </div>
      <br>
      <div class="row my-5">
        <div class="col text-center">
          <dx-tooltip
            position="bottom-center"
          >
            <template slot="trigger">
              Slot Slot Slot - Position Bottom Center
            </template>

            <template slot="content">
              Ich bin so ein content Slot
            </template>
          </dx-tooltip>
        </div>
      </div>
      <br>
      <div class="row my-5">
        <div class="col text-center">
          <dx-tooltip
            position="bottom-left"
          >
            <template slot="trigger">
              Slot Slot Slot Ich wurde per SLOT eingefügt Ich wurde per SLOT eingefügt - Position Bottom Left
            </template>

            <template slot="content">
              Ich bin so ein content Slot
            </template>
          </dx-tooltip>
        </div>
      </div>
      <br>
      <br>
      <div class="row my-5">
        <div class="col text-center">
          <dx-tooltip
            position="left"
          >
            <template slot="trigger">
              Slot Slot Slot - Position Bottom Left
            </template>

            <template slot="content">
              Ich bin so ein content Slot
            </template>
          </dx-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxButton,
  DxAccordion,
  DxInput,
  DxSelect,
  DxRadioList,
  DxRadioCheck,
  DxTextarea,
} from '@sumcumo/dextra-frontend-component-lib'
import DxShadowPageHead from '~/components/DX-ShadowPageHead'
import DxTooltip from '~/components/DX-Tooltip'

export default {
  name: 'Playground',
  components: {
    DxInput,
    DxTextarea,
    DxRadioCheck,
    DxRadioList,
    DxSelect,
    DxButton,
    DxAccordion,
    DxShadowPageHead,
    DxTooltip,
  },
  data() {
    return {
      testData: [
        {
          headline: 'Headline 1',
        },
      ],
    }
  },
}
</script>

<style>
/* DEMO STYLES */
.shadow-container--width {
  height: 270px;
  width: 100%;
}
</style>
